import { useEffect, useState } from "react";
import { MenuProps } from "../../interface/props/bcmenu";
import BcFooter from "../Bc-footer/BcFooter";
import BcIcon from "../Bc-Icon/Bc-icon";
import BcMenuLink from "../Bc-MenuLink/Bc-MenuLink";
import { menuUser, menuAdmin } from "../../../constants/menu";
import { MenuLink } from "../../interface/bcmenulink";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { Role } from "src/constants/roles";







const BcMenu = ({ children, activeMenu,  }: MenuProps) => {
  const [active, setActive] = useState<boolean>(activeMenu);

  const TOKEN = localStorage.getItem("token") as string;
  const USER: any = jwt_decode(TOKEN);

  const roleValide = USER["cognito:groups"].find((rol: string) => rol === Role.ADMIN)

  const navigate = useNavigate();

  const logout = () => {
    navigate("/logout", {replace: true})
  }

  useEffect(() => {
    setActive(activeMenu);
  }, [activeMenu]);


  return (
    <div className="bc-menu-global-container bc-menu-with-header">
      <nav className="bc-menu" id="menu">
        <ul
          className={`${
            active ? "bc-menu-drawer-content-active" : "bc-menu-drawer-content"
          }`}
        >  
          {roleValide && menuAdmin &&
            menuAdmin.map(({ path, iconLink, label }: MenuLink) => (
              <BcMenuLink key={path} path={path} iconLink={iconLink} label={label} />
            ))}

            {!roleValide && menuUser &&
            menuUser.map(({ path, iconLink, label }: MenuLink) => (
              <BcMenuLink key={path} path={path} iconLink={iconLink} label={label} />
            ))}

          <div className="bc-menu-submenu">
            <div className="bc-submenu-footer-container">
              <button
                type="button"
                className={`${
                  active
                    ? "bc-button bc-button-small bc-button-secondary expanded"
                    : "bc-fab-button bc-fab-button-mini"
                }`}
                onClick={() => logout()}
              >
                <BcIcon iconName="quit" />
                {active && <span>CERRAR SESIÓN</span>}
              </button>
            </div>
          </div>
        </ul>
      </nav>
      <div className="bc-content bc-container-solid bc-bg-light">
        {children}
        <BcFooter />
      </div>
    </div>
  );
};

export default BcMenu;
